import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "manual-test-agents"
};
const _hoisted_2 = ["onMouseenter", "onMouseleave", "onClick"];
const _hoisted_3 = {
  class: "manual-test-agents manual-test-cloud-agents"
};
const _hoisted_4 = ["onClick"];
import { ref, reactive, nextTick, watch } from 'vue';
import { mctRequest, globalRequest } from '@/api/axios';
import { zoneOs4ManualTestApi } from '@/api/management/manualTest';
import { ArrowRightBold } from '@element-plus/icons-vue';
import MctPopover from '@/components/mct-popover/index.vue';
import { storeToRefs } from 'pinia';
import { useUserDefaultSettingStore } from '@/store/user';
import { useManualTestStore } from '@/store/manualTest';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const userStore = useUserDefaultSettingStore();
    const {
      userCEC
    } = storeToRefs(userStore);
    const manualTestStore = useManualTestStore();
    const {
      manualTestTriggerPopoverVisible,
      manualTestTriggerEl,
      manualTestTriggerData,
      isShowManualTestDialog,
      manualTestDialogContentType
    } = storeToRefs(manualTestStore);
    const clickedLevel = ref('');
    const triggerManuelTestPopover = () => {
      const data = manualTestTriggerData.value;
      clickedLevel.value = data.level;
      if (['Zone', 'Server'].includes(clickedLevel.value)) {
        getZoneOs4ManualTest(data.zoneId);
      }
      showManualTestLocation();
    };
    const showMctPopover = isShow => {
      manualTestTriggerPopoverVisible.value = isShow;
    };
    const isShowGlobalAgentOrgs = ref(false);
    // const isShowGlobalAgents = ref(false)
    const adviceAgent = reactive({
      agent: 'GLOBAL_AGENT',
      vGroupId: 0
    });
    const clearAdviceAgentInfo = () => {
      adviceAgent.agent = 'GLOBAL_AGENT';
      adviceAgent.vGroupId = 0;
    };
    const globalAgentOrgs = ref([]);
    const showManualTestLocation = async () => {
      const clusterId = manualTestTriggerData.value?.clusterId || 0;
      const zoneId = manualTestTriggerData.value?.zoneId || 0;
      if (['Zone', 'Server'].includes(clickedLevel.value)) {
        // const id = manualTestTriggerData.value.zoneId
        const adviceAgentConfig = {
          url: `/monitor/timer-setting/advice-agent/zone/${zoneId}`
        };
        const {
          gAgentOrg
        } = await mctRequest.request(adviceAgentConfig);
        adviceAgent.agent = gAgentOrg.orgName;
        adviceAgent.vGroupId = gAgentOrg.vGroupId;
      }
      // console.log('data1', gAgentOrg)
      const globalAgentConfig = {
        url: `/agent/list/manualstation?zoneId=${zoneId}&clusterId=${clusterId}`
      };
      const {
        orgNameAgentMap
      } = await globalRequest.request(globalAgentConfig);
      const orgNameMap = new Map();
      globalAgentOrgs.value = [];
      if (orgNameAgentMap?.GLOBAL_AGENT) {
        for (const item of orgNameAgentMap['GLOBAL_AGENT']) {
          const {
            id,
            sIp,
            orgName,
            virtualGroupId
          } = item;
          const org = {
            id,
            sIp: '',
            orgName,
            virtualGroupId,
            isShowAgents: false
          };
          if (!orgNameMap.has(orgName)) {
            org.globalAgents = [];
            globalAgentOrgs.value.push(org);
            orgNameMap.set(orgName, org);
          }
          if (['Zone', 'Server'].includes(clickedLevel.value)) {
            const agentOS = item.sType;
            const roleIndex = item.sName.indexOf('[');
            const role = roleIndex === -1 ? '' : item.sName.substr(roleIndex);
            if (agentOS.toLowerCase().indexOf('windows') > -1 && zoneOS.value.toLowerCase().startsWith('win') || agentOS.toLowerCase().indexOf('linux') > -1 && zoneOS.value.toLowerCase().startsWith('cent')) {
              if (org.orgName === orgName) {
                const target = orgNameMap.get(orgName);
                target.globalAgents.push({
                  id,
                  sIp,
                  orgName: item.sIp + role,
                  virtualGroupId
                });
              }
            }
          }
        }
      }
    };
    const zoneOS = ref('');
    const getZoneOs4ManualTest = async zoneId => {
      const {
        zoneTemplate
      } = await zoneOs4ManualTestApi(zoneId);
      zoneOS.value = zoneTemplate?.oslist || 'WIN';
    };
    const popoverLeft = ref(165); // default position
    const manualTestBtn = ref(null);
    const popover = ref(null);
    const showGroupAgents = () => {
      isShowGlobalAgentOrgs.value = true;
      nextTick(() => {
        adjustPopoverPosition();
      });
    };
    const hideGroupAgents = () => {
      isShowGlobalAgentOrgs.value = false;
    };
    const adjustPopoverPosition = () => {
      if (manualTestBtn.value && popover.value) {
        const buttonRect = manualTestBtn.value.getBoundingClientRect();
        const popoverRect = popover.value.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        // 如果按钮靠近右侧屏幕，则调整 popover 位置到左侧
        if (buttonRect.right + popoverRect.width + 300 > viewportWidth) {
          popoverLeft.value = -popoverRect.width; // 调整到按钮左侧
        } else {
          popoverLeft.value = 165; // 保持默认位置
        }
      }
    };
    const showManualTestDialog = async (agent, vGroupId, identifier = '') => {
      const snd = Math.random() * 99999;
      const config = {
        url: `test/manual/${snd}`,
        method: 'post',
        urlParam: {
          _contentKey: 'mctStatusZone'
        },
        headers: {
          userName: userCEC.value
        },
        data: {
          clusterId: manualTestTriggerData.value?.clusterId || 0,
          mtype: clickedLevel.value === 'Zone' ? 2 : clickedLevel.value === 'Server' ? 3 : 0,
          serverIp: '',
          // do no need domainId anymore
          domainId: 0,
          zoneId: manualTestTriggerData.value?.zoneId || 0,
          serverId: manualTestTriggerData.value?.serverId || 0,
          serverType: 0,
          protocol: 0,
          agent,
          identifier,
          vGroupId
        }
      };
      await mctRequest.request(config);
      isShowManualTestDialog.value = true;
      manualTestDialogContentType.value = 'manualTestList';
      showMctPopover(false);
    };
    watch(manualTestTriggerPopoverVisible, () => {
      if (manualTestTriggerPopoverVisible.value) {
        triggerManuelTestPopover();
      } else {
        clearAdviceAgentInfo();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createBlock(MctPopover, {
        "is-show-popover": _unref(manualTestTriggerPopoverVisible),
        "trigger-element": _unref(manualTestTriggerEl),
        "z-index": 3000,
        "el-position": "right",
        onShowMctPopover: showMctPopover
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("button", {
          class: "pl-10",
          onClick: _cache[0] || (_cache[0] = $event => showManualTestDialog(adviceAgent.agent, adviceAgent.vGroupId))
        }, " Auto Assign "), _createElementVNode("button", {
          ref_key: "manualTestBtn",
          ref: manualTestBtn,
          class: "manual-test-btn pl-10",
          onMouseenter: showGroupAgents,
          onMouseleave: hideGroupAgents
        }, [_cache[1] || (_cache[1] = _createTextVNode(" Manually Assign ")), _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(ArrowRightBold))]),
          _: 1
        }), _withDirectives(_createElementVNode("div", {
          ref_key: "popover",
          ref: popover,
          class: "manual-test-agents manual-test-global-agents",
          style: _normalizeStyle({
            left: popoverLeft.value + 'px'
          })
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(globalAgentOrgs.value, group => {
          return _openBlock(), _createElementBlock("button", {
            key: group.id,
            class: "manual-test-btn pl-10",
            onMouseenter: $event => group.isShowAgents = true,
            onMouseleave: () => group.isShowAgents = false,
            onClick: $event => showManualTestDialog(group.orgName, group.virtualGroupId, group.sIp)
          }, [_createTextVNode(_toDisplayString(group.orgName) + " ", 1), group?.orgName?.startsWith('A') ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [['Zone', 'Server'].includes(clickedLevel.value) ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0
          }, {
            default: _withCtx(() => [_createVNode(_unref(ArrowRightBold))]),
            _: 1
          })) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.globalAgents, agent => {
            return _openBlock(), _createElementBlock("button", {
              key: agent.id,
              class: "cloud-agent-btn",
              onClick: _withModifiers($event => showManualTestDialog(group.orgName, agent.virtualGroupId, agent.sIp), ["stop"])
            }, _toDisplayString(agent.orgName), 9, _hoisted_4);
          }), 128))], 512), [[_vShow, group.isShowAgents]])], 64)) : _createCommentVNode("", true)], 40, _hoisted_2);
        }), 128))], 4), [[_vShow, isShowGlobalAgentOrgs.value]])], 544)])]),
        _: 1
      }, 8, ["is-show-popover", "trigger-element"]);
    };
  }
});